import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Clock } from "lucide-react";

export function AccountStatusBanner() {
  const { org } = useAuth();
  const { pathname } = useLocation();
  const [s, setS] = useState(null);
  useEffect(() => {
    if (org?.is_demo) return;
    Promise.all([api.get("/org/onboarding"), api.get("/billing/status")])
      .then(([o, b]) => setS({ texting: o.data.texting_status, billing: b.data.status, complete: o.data.complete }))
      .catch(() => {});
  }, [org?.id, pathname]);
  if (org?.is_demo) return (
    <div className="flex justify-end px-6 lg:px-10 pt-4">
      <span data-testid="demo-environment-label"
        title="All customers, conversations, appointments and revenue shown are fictional examples. Nothing is ever sent or charged."
        className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-slate-700 bg-slate-900/80 text-[11px] font-mono uppercase tracking-widest text-slate-300">
        <span className="w-1.5 h-1.5 rounded-full bg-amber-400" /> Demo Environment — Illustrative Data
      </span>
    </div>
  );
  if (!s || s.texting === "approved") return null;
  return (
    <div className="border-b border-sky-500/20 bg-sky-500/10 px-6 py-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm" data-testid="texting-pending-banner">
      <span className="flex items-center gap-2 text-sky-200 font-semibold"><Clock className="w-4 h-4" /> Texting Pending Approval</span>
      <span className="text-sky-200/70">Texts under your business name stay off until your own registration passes the Go-Live check.</span>
      {s.billing === "pending_activation" && <span className="text-sky-200/90" data-testid="banner-pending-activation">Payment received — Pending Activation</span>}
      <Link to={s.complete ? "/app/go-live" : "/app/onboarding"} className="text-orange-300 underline ml-auto" data-testid="banner-next-step">
        {s.complete ? "View Go-Live checklist" : "Finish onboarding"}
      </Link>
    </div>
  );
}
